import { CheckPermissionApi } from "./permission";
import { ROLE_USER_CONSTANT } from "../constants/roleUserConstant";
import { ROUTER_CONSTANT } from "../constants/routerConstant";
import {
    CONTACT_LIST_VIEW,
    DASHBOARD_CSO_VIEW,
    DASHBOARD_LEAD_VIEW,
    DASHBOARD_MANAGER_VIEW,
    DASHBOARD_PRINCIPAL_VIEW,
    EXPORT_TICKET_VIEW,
    MASTER_DATA_DATA_CUSTOMER_VIEW,
    MASTER_DATA_DATA_GROUP_VIEW,
    MASTER_DATA_IMPORT_VIEW,
    MASTER_DATA_USER_VIEW,
    PRINCIPAL_TICKET_REPORT_VIEW,
    PRINCIPAL_TICKET_REPORT_VIEW_OWN,
    PROFILE_USER_VIEW,
    SETTING_COMMISSION_VIEW,
    SETTING_CS_AGENT_VIEW,
    SETTING_ISSUE_CATEGORY_VIEW,
    SETTING_JOB_PROCESS_VIEW,
    SETTING_KMS_VIEW,
    SETTING_LOGIN_HISTORY_VIEW,
    SETTING_PARAMETER_VIEW,
    SETTING_QUEUE_VIEW,
    SETTING_SESSION_VIEW,
    TICKET_CREATE_INSERT,
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE,
    TICKET_LIST_MEMBER_VIEW,
    TICKET_LIST_NEW_CSO_VIEW,
    TICKET_LIST_NEW_MANAGER_VIEW,
    TICKET_LIST_NEW_VIEW,
    TICKET_LIST_SOLUTION_VIEW
} from "../constants/menuPermissionConstant";

export const redirectUri = (userDetail, history) => {
    if (!userDetail) return history.push(ROUTER_CONSTANT.LOGIN);
    let role = userDetail.nexcare_role;
    let permission = userDetail.permissions;
    if (role === ROLE_USER_CONSTANT.SUPER_ADMIN) return history.push(ROUTER_CONSTANT.DASHBOARD_MANAGER);
    if (CheckPermissionApi(DASHBOARD_PRINCIPAL_VIEW, permission)) return history.push(ROUTER_CONSTANT.DASHBOARD_PRINCIPAL);
    if (CheckPermissionApi(DASHBOARD_MANAGER_VIEW, permission)) return history.push(ROUTER_CONSTANT.DASHBOARD_MANAGER);
    if (CheckPermissionApi(DASHBOARD_LEAD_VIEW, permission)) return history.push(ROUTER_CONSTANT.DASHBOARD_LEAD);
    if (CheckPermissionApi(DASHBOARD_CSO_VIEW, permission)) return history.push(ROUTER_CONSTANT.DASHBOARD_OFFICER);
    if (CheckPermissionApi(TICKET_LIST_ALL_VIEW, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
    if (CheckPermissionApi(TICKET_LIST_ALL_VIEW_ASSIGNEE, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
    if (CheckPermissionApi(TICKET_LIST_NEW_VIEW, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_NEW);
    if (CheckPermissionApi(TICKET_LIST_NEW_CSO_VIEW, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_NEW);
    if (CheckPermissionApi(TICKET_LIST_NEW_MANAGER_VIEW, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_NEW);
    if (CheckPermissionApi(TICKET_LIST_MEMBER_VIEW, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_MEMBER);
    if (CheckPermissionApi(TICKET_CREATE_INSERT, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_CREATE);
    if (CheckPermissionApi(TICKET_LIST_SOLUTION_VIEW, permission)) return history.push(ROUTER_CONSTANT.TICKET_LIST_SOLUTION);
    if (CheckPermissionApi(CONTACT_LIST_VIEW, permission)) return history.push(ROUTER_CONSTANT.CONTACT);
    if (CheckPermissionApi(SETTING_CS_AGENT_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_CS_AGENT);
    if (CheckPermissionApi(SETTING_PARAMETER_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_PARAMETER);
    if (CheckPermissionApi(SETTING_KMS_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_KMS_LIST);
    if (CheckPermissionApi(SETTING_JOB_PROCESS_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_MONITORING);
    if (CheckPermissionApi(SETTING_LOGIN_HISTORY_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_LOGIN_HISTORY);
    if (CheckPermissionApi(SETTING_QUEUE_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_QUEUE_ASSIGNED);
    if (CheckPermissionApi(SETTING_SESSION_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_SESSION);
    if (CheckPermissionApi(SETTING_ISSUE_CATEGORY_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_CATEGORY_ISSUE);
    if (CheckPermissionApi(SETTING_COMMISSION_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETTINGS_COMMISSION_SCHEME);
    if (CheckPermissionApi(MASTER_DATA_DATA_GROUP_VIEW, permission)) return history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP);
    if (CheckPermissionApi(MASTER_DATA_USER_VIEW, permission)) return history.push(ROUTER_CONSTANT.MASTER_DATA_USER);
    if (CheckPermissionApi(MASTER_DATA_DATA_CUSTOMER_VIEW, permission)) return history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_CUSTOMER);
    if (CheckPermissionApi(MASTER_DATA_IMPORT_VIEW, permission)) return history.push(ROUTER_CONSTANT.MASTER_DATA_IMPORT);
    if (CheckPermissionApi(PROFILE_USER_VIEW, permission)) return history.push(ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS);
    if (CheckPermissionApi(PRINCIPAL_TICKET_REPORT_VIEW, permission)) return history.push(ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET);
    if (CheckPermissionApi(PRINCIPAL_TICKET_REPORT_VIEW_OWN, permission)) return history.push(ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET);
    if (CheckPermissionApi(EXPORT_TICKET_VIEW, permission)) return history.push(ROUTER_CONSTANT.REPORT_EXPORT_TICKET);
}

export const openWindow = userDetail => {
    if (!userDetail) return ROUTER_CONSTANT.LOGIN;
    let role = userDetail.nexcare_role;
    let permission = userDetail.permissions;
    if (role === ROLE_USER_CONSTANT.SUPER_ADMIN) return ROUTER_CONSTANT.DASHBOARD_MANAGER;
    if (CheckPermissionApi(DASHBOARD_PRINCIPAL_VIEW, permission)) return ROUTER_CONSTANT.DASHBOARD_PRINCIPAL;
    if (CheckPermissionApi(DASHBOARD_MANAGER_VIEW, permission)) return ROUTER_CONSTANT.DASHBOARD_MANAGER;
    if (CheckPermissionApi(DASHBOARD_LEAD_VIEW, permission)) return ROUTER_CONSTANT.DASHBOARD_LEAD;
    if (CheckPermissionApi(DASHBOARD_CSO_VIEW, permission)) return ROUTER_CONSTANT.DASHBOARD_OFFICER;
    if (CheckPermissionApi(TICKET_LIST_ALL_VIEW, permission)) return ROUTER_CONSTANT.TICKET_LIST_ALL;
    if (CheckPermissionApi(TICKET_LIST_ALL_VIEW_ASSIGNEE, permission)) return ROUTER_CONSTANT.TICKET_LIST_ALL;
    if (CheckPermissionApi(TICKET_LIST_NEW_VIEW, permission)) return ROUTER_CONSTANT.TICKET_LIST_NEW;
    if (CheckPermissionApi(TICKET_LIST_NEW_CSO_VIEW, permission)) return ROUTER_CONSTANT.TICKET_LIST_NEW;
    if (CheckPermissionApi(TICKET_LIST_NEW_MANAGER_VIEW, permission)) return ROUTER_CONSTANT.TICKET_LIST_NEW;
    if (CheckPermissionApi(TICKET_LIST_MEMBER_VIEW, permission)) return ROUTER_CONSTANT.TICKET_LIST_MEMBER;
    if (CheckPermissionApi(TICKET_CREATE_INSERT, permission)) return ROUTER_CONSTANT.TICKET_LIST_CREATE;
    if (CheckPermissionApi(TICKET_LIST_SOLUTION_VIEW, permission)) return ROUTER_CONSTANT.TICKET_LIST_SOLUTION;
    if (CheckPermissionApi(CONTACT_LIST_VIEW, permission)) return ROUTER_CONSTANT.CONTACT;
    if (CheckPermissionApi(SETTING_CS_AGENT_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_CS_AGENT;
    if (CheckPermissionApi(SETTING_PARAMETER_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_PARAMETER;
    if (CheckPermissionApi(SETTING_KMS_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_KMS_LIST;
    if (CheckPermissionApi(SETTING_JOB_PROCESS_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_MONITORING;
    if (CheckPermissionApi(SETTING_LOGIN_HISTORY_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_LOGIN_HISTORY;
    if (CheckPermissionApi(SETTING_QUEUE_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_QUEUE_ASSIGNED;
    if (CheckPermissionApi(SETTING_SESSION_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_SESSION;
    if (CheckPermissionApi(SETTING_ISSUE_CATEGORY_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_CATEGORY_ISSUE;
    if (CheckPermissionApi(SETTING_COMMISSION_VIEW, permission)) return ROUTER_CONSTANT.SETTINGS_COMMISSION_SCHEME;
    if (CheckPermissionApi(MASTER_DATA_DATA_GROUP_VIEW, permission)) return ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP;
    if (CheckPermissionApi(MASTER_DATA_USER_VIEW, permission)) return ROUTER_CONSTANT.MASTER_DATA_USER;
    if (CheckPermissionApi(MASTER_DATA_DATA_CUSTOMER_VIEW, permission)) return ROUTER_CONSTANT.MASTER_DATA_DATA_CUSTOMER;
    if (CheckPermissionApi(MASTER_DATA_IMPORT_VIEW, permission)) return ROUTER_CONSTANT.MASTER_DATA_IMPORT;
    if (CheckPermissionApi(PROFILE_USER_VIEW, permission)) return ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS;
    if (CheckPermissionApi(PRINCIPAL_TICKET_REPORT_VIEW, permission)) return ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET;
    if (CheckPermissionApi(PRINCIPAL_TICKET_REPORT_VIEW_OWN, permission)) return ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET;
    if (CheckPermissionApi(EXPORT_TICKET_VIEW, permission)) return ROUTER_CONSTANT.REPORT_EXPORT_TICKET;
}